<template>
  <a-layout>
    <a-layout-content>
      <a-page-header @back="this.goBack"
                     :title="this.$route.meta.title"
                     :sub-title="this.$route.meta.subTitle"
                     class="vd-gl-header-warp"/>
      <div class="vd-gl-content">
        123
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
  export default {
    name: 'user',
  }
</script>

<style scoped>

</style>